import React from "react";
import FontAwesome from "react-fontawesome";
import styled, { css } from "styled-components";
import { Button, LinearProgress } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
function Modal({
    isShow = false,
    children,
    isLoading = false,
    disable = false,
    btnTextConfirm = "Lưu",
    btnTextCancel = "Thoát",
    showModalFooter = true,
    onSetIsShow = () => { },
    onSubmit = () => { },
    onClose = () => { },
    ...props
}
) {
    return (
        isShow
            ? (<ModalStyle className="modal" {...props}>
                <div
                    onClick={() => {
                        onSetIsShow(false)
                        onClose();
                    }}
                    className="modalOuter" />
                <div id="modalDialog" className={["modalDialog", props.classDialog].join(" ")}>
                    {
                        isLoading && (<div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%"
                        }}>
                            <LinearProgress></LinearProgress>
                        </div>)
                    }
                    <div className="modalHeader">
                        <FontAwesome
                            onClick={() => {
                                onClose();
                                onSetIsShow(false)
                            }}
                            name="times" className="btnExist" />
                    </div>
                    <div className="modalContent">
                        {children}
                    </div>
                    {
                        showModalFooter
                            ? (<div className="modalFooter">
                                <Button
                                    onClick={() => {
                                        onSetIsShow(false)
                                        onClose();
                                    }}
                                    className={["btnCancel"].join(" ")} variant="outlined" size="small">
                                    {btnTextCancel}
                                </Button>
                                <LoadingButton
                                    loading={isLoading}
                                    onClick={onSubmit}
                                    variant="contained" size="small">
                                    {btnTextConfirm}
                                </LoadingButton>
                            </div>)
                            : null
                    }
                </div>
            </ModalStyle>)
            : null
    );
}

const ModalStyle = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 100;
    overflow: hidden;
    ${(props) => {
        return props.zIndex && css`
        z-index:${props.zIndex};
    `
    }
    }
    form{
        padding: 20px 0;
    }
    .modalOuter {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .modalDialog{
        position: absolute;
        background-color: #fff;
        box-shadow: 0px 0px 10px var(--gray-light);
        left: 50%;
        transform: translate(-50%, 20px);
        padding: 20px;
        border-radius: 3px;
        ${(props) => {
        switch (props.position) {
            case "top":
                return css`
                            top:10px;
                        `
            case "center":
                return css`
                            top:50%;
                            transform: translate(-50%, -50%);
                        `
            default:
        }
    }
    }
        ${(props) => {
        return props.height && css`
                height:${props.height};
            `
    }
    }
        ${(props) => {
        switch (props.size) {
            case "sm":
                return css`
                            width:400px;
                            @media(max-width:487px){
                                width:93%;
                            }
                        `
            case "xl":
                return css`
                        width:834px;
                        @media(max-width:834px){
                            width:93%;
                        }
                    `
            case "lg":
                return css`
                width:1028px;
                @media(max-width:834px){
                    width:93%;
                }
                `
            default:
        }
    }
    }
        .modalHeader{
            .btnExist {
                background-color: var(--light);
                padding: 5px;
                box-shadow: 0px 0px 10px var(--gray-light);
                border-radius: 50%;
                width: 40px;
                height: 40px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: -10px;
                top: -15px;
                cursor: pointer;
                z-index: 10;
            }
        }
        .modalContent{
            max-height: calc(80vh);
            overflow-y: auto;
        }
        .modalFooter{
            float:right;
            .btnCancel{
                margin-right:5px;
            }
        }
    }
`;

export default Modal;